<template>
  <div>
    <label>{{ column.label }}</label>
    <v-text-field
      background-color="#fafafa"
      dense
      outlined
      v-model="model"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    formData: Object,
    column: Object,
  },
  computed: {
    nestedProp() {
      return this.column.prop.includes(".");
    },
    model: {
      get() {
        if (this.nestedProp) {
          let props = this.column.prop.split(".");

          return this.formData[props[0][props[1]]];
        } else {
          return this.formData[this.column.prop];
        }
      },
      set(val) {
        if (this.nestedProp) {
          let props = this.column.prop.split(".");

          return (this.formData[props[0]][props[1]] = val);
        } else {
          return (this.formData[this.column.prop] = val);
        }
      },
    },
  },
  mounted() {},
};
</script>